package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class ContentType(private val literal: String) : IEnumType {
	BookContent("BookContent"),
	News("News"),
	Policy("Policy"),
	Topic("Topic"),
	Note("Note"),
	Moment("Moment"),
	Article("Article"),
	Meridian("Meridian"),
	Guideline("Guideline"),
	TcmFaq("TcmFaq");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "content_type"}
	override fun getLiteral(): String {return literal}
}
